module.exports = __webpack_public_path__ + "img/notify.1e62fd2f.svg";